import BadgesComponent from "@components/common/Badges";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@store/reducers";
import { useDispatch } from "react-redux";
import { updatePNC } from "@store/actions/beneficiaryAction";
import { formatName } from "@pages/Beneficiary-block/WomenComponent/PregnancyTracking/pregnancyUtils";
import { PNC_CHILD_SERVICE } from "../../ANC/Forms/CreateAndEdit/ancConstants";
import './CreateChildPNC.css';
import { getCompletedHbncServiceList } from "../PNCServices";
import { errorLogger } from "@utils/applicationLogUtils";


const ChildPNCView = () => {
    const viewEditMetaData = useSelector((state: RootState) => state.beneficiary.viewEditMetaData);
    const [pncServiceData, setPncServiceData] = useState<any>([]);
    const dispatch = useDispatch();    

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try{
        const res = await getCompletedHbncServiceList(viewEditMetaData?.serviceVisitId);
        if(res) {
            mapData(res);
        }
        } catch(error:any) {
            errorLogger(error?.response?.data||error?.response||error)
        }
    }

    const mapData = (data:any) => {
        const initialState = {
            exclusiveBreastFeeding: { value: null},
            babyTestedForHiv: { value: null},
            referredToNacpReferralFacility: { value: null},
            dangerSigns: { value: null},
            referredToHigherFacilityForDangerSigns: { value: null},
            dangerSignTreatmentInfo: { value: null},
            VisibleBirthDefects: { value: null},
            referredToHigherFacilityForBirthDefect: { value: null},
            defectTreatmentInfo: { value: null},
            methodOfTreatment: { value: null},
          };

          const updatedFormState = (() => {
            try {
                return data?.data?.reduce((acc: any, item: any) => {
                    switch (item.service_code) {
                        case PNC_CHILD_SERVICE.EXCLUSIVE_BREASTFEEDING_CONTINUED:
                            acc.exclusiveBreastFeeding.value = item.service_report || '-';                            
                            break;
                        case PNC_CHILD_SERVICE.HIV_TEST_FOR_BABY:
                            acc.babyTestedForHiv.value = item.service_report || 'Not Done';
                            break;
                        case PNC_CHILD_SERVICE.DANGER_SIGNS:
                            acc.dangerSigns.value = acc.dangerSigns.value
                                ? `${acc.dangerSigns.value}, ${item.service_report}`
                                : item.service_report || '-';
                            acc.dangerSignTreatmentInfo.value = item.child_treatment_type_name;
                            break;
                        case PNC_CHILD_SERVICE.VISIBLE_BIRTH_DEFECTS:
                            acc.VisibleBirthDefects.value = acc.VisibleBirthDefects.value
                                ? `${acc.VisibleBirthDefects.value}, ${item.service_report}`
                                : item.service_report || '-';
                            acc.methodOfTreatment.value = item.method_of_treatment_name || '-'; 
                            acc.defectTreatmentInfo.value = item.child_treatment_type_name;
                            break;
                        case PNC_CHILD_SERVICE.REFERRED_TO_HIGHER_FACILITY_FOR_DANGER_SIGNS:
                            acc.referredToHigherFacilityForDangerSigns.value = item.service_report || '-';
                            break;
                        case PNC_CHILD_SERVICE.REFERRED_TO_HIGHER_FACILITY_FOR_BIRTH_DEFECTS:
                            acc.referredToHigherFacilityForBirthDefect.value = item.service_report || '-';
                            break;
                        case PNC_CHILD_SERVICE.NACP_REFERRAL_FACILITY:
                            acc.referredToNacpReferralFacility.value = item.service_report || '-';
                            break;
                        default:
                            break;
                    }
                    return acc;
                }, initialState);
            } catch (error) {
                return initialState;
            }
        })();
        const facilityDetailsObj = data?.data?.[0];
        if (facilityDetailsObj) {
            const {
                facility_name,
                facility_type_name,
                healthprovider_f_name,
                healthprovider_l_name,
                mobiliser_f_name,
                mobiliser_l_name,
            } = facilityDetailsObj;
    
            const healthProviderName = formatName(healthprovider_f_name, healthprovider_l_name);
            const mobiliserName = formatName(mobiliser_f_name, mobiliser_l_name);
            const localFacilityDetails = { facility_name, facility_type_name, healthProviderName, mobiliserName };
            dispatch(updatePNC("viewAndEditFacilityDetails", localFacilityDetails));
        }
    
        setPncServiceData(updatedFormState);
    }


    return (
    <>
        <div className="overview_pnc">
            <BadgesComponent
                className="over-badge"
                badgeName="PNC Child Details"
                variant="primary-1"
                badgeType="case5"
            />
            <div className="overview-details">
            <div>
                <label className="overview-details-label">Exclusive Breast Feeding Continuing?</label>
                <div className="overview-details-value">
                    {pncServiceData?.exclusiveBreastFeeding?.value || '-'}
                </div>
            </div>
            <div>
                <label className="overview-details-label">Whether baby tested for HIV?</label>
                <div className="overview-details-value">
                    {pncServiceData?.babyTestedForHiv?.value || '-'}
                </div>
            </div>
             <div>
                <label className="overview-details-label">Referred to NACP referral facility</label>
                <div className="overview-details-value">
                    {pncServiceData?.referredToNacpReferralFacility?.value || '-'}
                </div>
            </div>
            <div>
                <label className="overview-details-label">Indicate Danger Signs (If any) present in Baby</label>
                <div className="overview-details-value">
                    {pncServiceData?.dangerSigns?.value || '-'}
                </div>
            </div>
            <div>
                <label className="overview-details-label">Treated/Referred to a Higher Facility</label>
                <div className="overview-details-value">
                    {pncServiceData?.dangerSignTreatmentInfo?.value || '-'}
                </div>
            </div>
            <div>
                <label className="overview-details-label">Any visible birth defect seen?</label>
                <div className="overview-details-value">
                    {pncServiceData?.VisibleBirthDefects?.value || '-'}
                </div>
            </div>
            <div>
                <label className="overview-details-label">Treated/Referred to a Higher Facility</label>
                <div className="overview-details-value">
                    {pncServiceData?.defectTreatmentInfo?.value || '-'}
                </div>
            </div>       
            <div>
                <label className="overview-details-label">Method of Treatment(If Treatment done)</label>
                <div className="overview-details-value">
                    {pncServiceData?.methodOfTreatment?.value || '-'}
                </div>
            </div>           
           
            </div>
        </div>        
    </>
    );
}
export default ChildPNCView;